






import { Component, Vue } from 'vue-property-decorator';
import RecurringOrderList from '@/components/Invoicing/RecurringOrder/RecurringOrderList.vue';

@Component({
  components: {
    RecurringOrderList,
  },
})
export default class RecurringOrders extends Vue {
}
